// extracted by mini-css-extract-plugin
module.exports = {"virtual-agent-area":"printer_virtual-agent-area__5_d7t"};